import React from 'react';
import { Box, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { Message } from '@getro/rombo';
import { CompaniesList } from '../companiesList';

const CompaniesLayout = ({ sharedList, isLoadingSharedList, failedDomains }) => (
  <Box pt="24px" width="100%" ml="-1px">
    {failedDomains.length > 0 && (
      <Box sx={{ mx: '16px', mb: '16px' }}>
        <Message
          type="warning"
          content={
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', color: 'text.main' }}>
              <Box>
                The list was created but the following companies were not added because they are not hosting a valid
                website:
              </Box>
              <Box as="ul" sx={{ display: 'flex', flexDirection: 'column', gap: '4px', pl: '24px' }}>
                {failedDomains.map((domain) => (
                  <Text as="li" key={domain}>
                    {domain}
                  </Text>
                ))}
              </Box>
            </Box>
          }
        />
      </Box>
    )}
    <CompaniesList sharedList={sharedList} isLoadingSharedList={isLoadingSharedList} />
  </Box>
);

CompaniesLayout.propTypes = {
  sharedList: PropTypes.object,
  isLoadingSharedList: PropTypes.bool,
  failedDomains: PropTypes.array,
};

CompaniesLayout.defaultProps = {
  sharedList: {},
  isLoadingSharedList: false,
  failedDomains: [],
};

export default CompaniesLayout;
